import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';

const Controllers = ({
  config = undefined,
  data = undefined,
  selectedColumn = undefined,
  selectedLine = undefined,
  selectedFunction = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
}) => (
  <>
    {[GeneralControllers, StyleControllers].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedColumn={selectedColumn}
        selectedLine={selectedLine}
        selectedFunction={selectedFunction}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  selectedColumn: PropTypes.shape({}),
  selectedLine: PropTypes.shape({}),
  selectedFunction: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
};

export default Controllers;
